export default "__VITE_PUBLIC_ASSET__4c6d69a0__"